import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { tagsApi } from '../../services/api';

// Async thunks
export const fetchTags = createAsyncThunk(
    'tags/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await tagsApi.getAll();
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch tags');
        }
    }
);

export const createTag = createAsyncThunk(
    'tags/create',
    async (tag, { rejectWithValue }) => {
        try {
            const response = await tagsApi.create(tag);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to create tag');
        }
    }
);

export const deleteTag = createAsyncThunk(
    'tags/delete',
    async (id, { rejectWithValue }) => {
        try {
            await tagsApi.delete(id);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to delete tag');
        }
    }
);

const initialState = {
    items: [],
    loading: false,
    error: null,
};

const tagsSlice = createSlice({
    name: 'tags',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTags.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTags.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload || [];
            })
            .addCase(fetchTags.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createTag.fulfilled, (state, action) => {
                state.items.push(action.payload);
            })
            .addCase(deleteTag.fulfilled, (state, action) => {
                state.items = state.items.filter(item => item.id !== action.payload);
            });
    },
});

export const { clearError } = tagsSlice.actions;
export default tagsSlice.reducer;
